<template>
  <div class="iagIndex">
    <div class="feil_menu">
      <div class="feil_menu_title">IAG</div>
      <div class="feil_menu_item">
        <el-tree
          :data="feilListData"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expanded-keys="unfoldArr"
          accordion
          :highlight-current="true"
          ref="tree"
        >
        <span class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
        </span>
        </el-tree>
      </div>
    </div>
    <div class="feil_main">
      <div class="feil_main_title">{{this.mainTitle}}</div>
      <div class="feil_main_item" v-if="fileMainItemData&&fileMainItemData.length>0">
        <ul class="feil_main_item_ul">
          <li v-for="val in this.fileMainItemData" :key="val.id" class="feil_main_item_li">
            <div class="content" @click="downFeil(val.fileUrl,val.fileType)">
              <div class="content_icon">
                <img
                  :src="fileImg.ppt"
                  alt="ppt"
                  v-if="val.fileType == 'pptx'"
                />
                <img
                  :src="fileImg.doc"
                  alt="doc"
                  v-else-if="val.fileType == 'doc'"
                />
                <img
                  :src="fileImg.pdf"
                  alt="pdf"
                  v-else-if="val.fileType == 'pdf'"
                />
                <svg-icon
                  icon-class="image"
                  v-else-if="val.fileType == 'jpg' || val.fileType == 'png'"
                />
                <svg-icon icon-class="XLS" v-else-if="val.fileType == 'xlsx'" />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'video'"
                />
              </div>
              <div class="content_title">
                <p>{{ val.fileName }}</p>
              </div>
              <div class="content_down">
                <svg-icon icon-class="download" v-if="val.fileType != 'link'&&val.fileType != 'video'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="feil_main_item" v-else>
        <div class="noDetail">
          <svg-icon icon-class="nodeta"/>
          <p>No Data</p>
        </div>
      </div>
      <el-pagination layout="prev, pager, next" :total="pagination.total" :page-size="pagination.pageSize" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: "iagIndex",
  data() {
    return {
      showItem: 1,
      mainTitle: "IAG Demo",
      unfoldArr: [1],
      pagination: {
        page: 0,
        pageSize: 8,
        total: 0,
        data: [],
      },
      fileMainItemData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      feilListData:[
        {
          label: "Product Introduction",
          id: 1,
          children: [
            { label: "IAG Demo", child_id: 1, id: 20 },
            { label: "Main Slides", child_id: 2 },
            { label: "Product Video", child_id: 3 },
            { label: "Feature List", child_id: 4 },
            { label: "Capacity Limit and Supported Feature Based on Deployment Mode", child_id: 5 },
          ],
        },
        {
          label: "Sales Guidance",
          id: 2,
          children: [
            { label: "Cheatsheet", child_id: 6},
            { label: "Sales Scenario", child_id: 7 },
            { label: "Case Study", child_id: 8 },
            { label: "Product Endorsement Certification", child_id: 9 },
            { label: "Brochure", child_id: 10 },
          ],
        },
        {
          label: "Battle Card",
          id: 3,
          children: [
            { label: "Sales Battle Cards", child_id: 11},
          ],
        },
        {
          label: "Sizing Guide",
          id: 4,
          children: [
            { label: "Sizing Guide", child_id: 12},
          ],
        },
        {
          label: "POC Docs",
          id: 5,
          children: [
            { label: "User Manual", child_id: 13},
            { label: "POC Check List", child_id: 14},
            { label: "Implementation Guide", child_id: 15},
            { label: "Configuration Guide", child_id: 20},
          ],
        },
        {
          label: "Bidding Doc",
          id: 6,
          children: [
            { label: "Bidding", child_id: 16},
            { label: "Release Notes", child_id: 21},
            { label: "Troubleshooting Guide", child_id: 22},
          ],
        },
        {
          label: "Technical Material",
          id: 7,
          children: [
            { label: "IAG(IAM) Associate & Professional Training", child_id: 17},
          ],
        },
        {
          label: "Training Docs",
          id: 8,
          children: [
            { label: "Internal Training", child_id: 18},
            { label: "Partner Training", child_id: 19},
            { label: "Video Training", child_id: 23},
          ],
        },
      ],
      feilIndexData:{
        1:[
          {
            id:1,
            fileName:'IAG demo',
            fileUrl:'https://demo.sangfor.com:446/',
            fileType:'video',
          },
        ],
        2:[
          {
            id:1,
            fileName:'2019 IAM Sales Slides .pptx',
            fileUrl:'2019 IAM Sales Slides .pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'IAG_Main_Sales_v4.pptx',
            fileUrl:'IAG_Main_Sales_v4.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'IAG_Main_Sales_v8.pptx',
            fileUrl:'IAG_Main_Sales_v8.pptx',
            fileType:'pptx',
          },
        ],
        3:[
          {
            id:1,
            fileName:'Product video',
            fileUrl:'https://youtu.be/tEwtSvLHyKY',
            fileType:'video',
          },
        ],
        4:[
          {
            id:1,
            fileName:'IAM Feature Changes11.0-12.0.25.xlsx',
            fileUrl:'IAM Feature Changes11.0-12.0.25.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'SFRD-VER-06-2.2_IAG13.0.15 Feature Changes and Pending Issues.xlsx',
            fileUrl:'SFRD-VER-06-2.2_IAG13.0.15 Feature Changes and Pending Issues.xlsx',
            fileType:'xlsx',
          },
          {
            id:3,
            fileName:'SFRD-VER-06-2.2_IAM12.0.25  Feature Changes and Pending Issues.xls',
            fileUrl:'SFRD-VER-06-2.2_IAM12.0.25  Feature Changes and Pending Issues.xls',
            fileType:'xlsx',
          },
          {
            id:4,
            fileName:'SFRD-VER-06-2.2_IAM13.0.8 Feature Changes and Pending Issues.xls',
            fileUrl:'SFRD-VER-06-2.2_IAM13.0.8 Feature Changes and Pending Issues.xls',
            fileType:'xlsx',
          },
        ],
        5:[
          {
            id:1,
            fileName:'AC13.0.15 Capacity Limit.xlsx',
            fileUrl:'AC13.0.15 Capacity Limit.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'AC13.0.15 Supported Feature Based on Deployment Mode.xlsx',
            fileUrl:'AC13.0.15 Supported Feature Based on Deployment Mode.xlsx',
            fileType:'xlsx',
          },
        ],
        6:[
          {
            id:1,
            fileName:'IAG Cheatsheet_v1.pptx',
            fileUrl:'IAG Cheatsheet_v1.pptx',
            fileType:'pptx',
          },
        ],
        7:[
          {
            id:1,
            fileName:'IAM main sales scenario and target market 20190610.pptx',
            fileUrl:'IAM main sales scenario and target market 20190610.pptx',
            fileType:'pptx',
          },
        ],
        8:[
          {
            id:1,
            fileName:'Case Study_IAM_ENP_Transparent&amp;amp;Multi Branch_Veolia_20160724_Simon.pptx',
            fileUrl:'Case Study_IAM_ENP_Transparent&amp;amp;Multi Branch_Veolia_20160724_Simon.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'Case Study_IAM_FSI_Gateway_CMS_20160720_Simon.pptx',
            fileUrl:'Case Study_IAM_FSI_Gateway_CMS_20160720_Simon.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Case Study_IAM_Gov_Transparent_外交部驻港公署_20160823_Simon.pptx',
            fileUrl:'Case Study_IAM_Gov_Transparent_外交部驻港公署_20160823_Simon.pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'Case Study_IAM_Hotel_Transparent_Regal_20160722_Simon.pptx',
            fileUrl:'Case Study_IAM_Hotel_Transparent_Regal_20160722_Simon.pptx',
            fileType:'pptx',
          },
          {
            id:5,
            fileName:'IAM_CS_P_CIB-Case-Study_20141023.pdf',
            fileUrl:'IAM_CS_P_CIB-Case-Study_20141023.pdf',
            fileType:'pdf',
          },
          {
            id:6,
            fileName:'IAM_CS_P_Westin-Malaysia-Case-Study_20141023.pdf',
            fileUrl:'IAM_CS_P_Westin-Malaysia-Case-Study_20141023.pdf',
            fileType:'pdf',
          },
          {
            id:7,
            fileName:'IAM_I_LionAir-Case-Study_20150303.pdf',
            fileUrl:'IAM_I_LionAir-Case-Study_20150303.pdf',
            fileType:'pdf',
          },
          {
            id:8,
            fileName:'IAM_P_ChandraAsri-Case-Study_20141127.pdf',
            fileUrl:'IAM_P_ChandraAsri-Case-Study_20141127.pdf',
            fileType:'pdf',
          },
          {
            id:9,
            fileName:'IAM_P_ShellSG-Case-Study_20141126.pdf',
            fileUrl:'IAM_P_ShellSG-Case-Study_20141126.pdf',
            fileType:'pdf',
          },
          {
            id:10,
            fileName:'Ministry of indonesia.pdf',
            fileUrl:'Ministry of indonesia.pdf',
            fileType:'pdf',
          },
          {
            id:11,
            fileName:'Pemda(Province).pdf',
            fileUrl:'Pemda(Province).pdf',
            fileType:'pdf',
          },
          {
            id:12,
            fileName:'WANOIAM_CS_P_KIBB-Case-Study_20141023.pdf',
            fileUrl:'WANOIAM_CS_P_KIBB-Case-Study_20141023.pdf',
            fileType:'pdf',
          },
          {
            id:13,
            fileName:'招商证券(香港)-sangfor案例 V2.pdf',
            fileUrl:'招商证券(香港)-sangfor案例 V2.pdf',
            fileType:'pdf',
          },
          {
            id:14,
            fileName:'Sangfor_MY_GOV_Majlis Bandaraya Petaling Jaya.JPG',
            fileUrl:'Sangfor_MY_GOV_Majlis Bandaraya Petaling Jaya.JPG',
            fileType:'jpg',
          },
        ],
        9:[
          {
            id:1,
            fileName:'AC-IPv6 Ready Phase-2 (1).pdf',
            fileUrl:'AC-IPv6 Ready Phase-2 (1).pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'CE-E (1).pdf',
            fileUrl:'CE-E (1).pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'FCC (1).pdf',
            fileUrl:'FCC (1).pdf',
            fileType:'pdf',
          },
        ],
        10:[
          {
            id:1,
            fileName:'IAG_BR_P_IAG-Brochure_20210601.pdf',
            fileUrl:'IAG_BR_P_IAG-Brochure_20210601.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'IAM_BR_P_IAM-Brochure_20190829.pdf',
            fileUrl:'IAM_BR_P_IAM-Brochure_20190829.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'IAM_BR_P_IAM-Brochure_20210121.pdf',
            fileUrl:'IAM_BR_P_IAM-Brochure_20210121.pdf',
            fileType:'pdf',
          },
        ],
        11:[
          {
            id:1,
            fileName:'Comparable Matrix IAM - ForcePoint.xlsx',
            fileUrl:'Comparable Matrix IAM - ForcePoint.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'IAM_BattleCard-IAM-vs-BlueCoat-201801024.pptx',
            fileUrl:'IAM_BattleCard-IAM-vs-BlueCoat-201801024.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'IAM_BattleCard-IAM-vs-Cisco Web Security 20180626.pptx',
            fileUrl:'IAM_BattleCard-IAM-vs-Cisco Web Security 20180626.pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'IAM_BattleCard-IAM-vs-Mcafee 20180904.pptx',
            fileUrl:'IAM_BattleCard-IAM-vs-Mcafee 20180904.pptx',
            fileType:'pptx',
          },
          {
            id:5,
            fileName:'IAM_BattleCard-IAM-vs-TMG_20180622.pptx',
            fileUrl:'IAM_BattleCard-IAM-vs-TMG_20180622.pptx',
            fileType:'pptx',
          },
          {
            id:6,
            fileName:'IAM_Competition-material-IAM-vs-Bluecoat_201707.xlsx',
            fileUrl:'IAM_Competition-material-IAM-vs-Bluecoat_201707.xlsx',
            fileType:'xlsx',
          },
          {
            id:7,
            fileName:'Sangfor IAG Battledeck_12Jan2021.xlsx',
            fileUrl:'Sangfor IAG Battledeck_12Jan2021.xlsx',
            fileType:'xlsx',
          },
          {
            id:8,
            fileName:'Sangfor IAM VS Allot.xlsx',
            fileUrl:'Sangfor IAM VS Allot.xlsx',
            fileType:'xlsx',
          },
          {
            id:9,
            fileName:'Sangfor IAM VS Barracuda web filter.docx',
            fileUrl:'Sangfor IAM VS Barracuda web filter.docx',
            fileType:'doc',
          },
          {
            id:10,
            fileName:'SANGFOR IAM vs FortiGate.pdf',
            fileUrl:'SANGFOR IAM vs FortiGate.pdf',
            fileType:'pdf',
          },
        ],
        12:[
          {
            id:1,
            fileName:'SANGFOR_IAG_New_ Sizing Guide-20210528.xlsx',
            fileUrl:'SANGFOR_IAG_New_ Sizing Guide-20210528.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'SANGFOR_IAM_12.0.18_ Sizing Guide-20190305.xlsx',
            fileUrl:'SANGFOR_IAM_12.0.18_ Sizing Guide-20190305.xlsx',
            fileType:'xlsx',
          },
          {
            id:3,
            fileName:'SANGFOR_IAM_New_ Sizing Guide-20200701.xlsx',
            fileUrl:'SANGFOR_IAM_New_ Sizing Guide-20200701.xlsx',
            fileType:'xlsx',
          },
          {
            id:4,
            fileName:'SANGFOR_IAM_New_ Sizing Guide-20201113.xlsx',
            fileUrl:'SANGFOR_IAM_New_ Sizing Guide-20201113.xlsx',
            fileType:'xlsx',
          },
        ],
        13:[
          {
            id:1,
            fileName:'SANGFOR_IAG_v13.0.15_user manual_20210331.pdf',
            fileUrl:'SANGFOR_IAG_v13.0.15_user manual_20210331.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'SANGFOR_IAM_v12.0.17_User Manual_201901.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.17_User Manual_201901.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'SANGFOR_IAM_v12.0.41_User Manual_201902.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.41_User Manual_201902.pdf',
            fileType:'pdf',
          },
        ],
        14:[
          {
            id:1,
            fileName:'POC PROCESS Flow Chat_v2.0.pdf',
            fileUrl:'POC PROCESS Flow Chat_v2.0.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'Sangfor Pre-POC Check list_IAM_20190617.xlsx',
            fileUrl:'Sangfor Pre-POC Check list_IAM_20190617.xlsx',
            fileType:'xlsx',
          },
          {
            id:3,
            fileName:'SANGFOR_IAM_Pre-POC Checklist_v1.0.xlsx',
            fileUrl:'SANGFOR_IAM_Pre-POC Checklist_v1.0.xlsx',
            fileType:'xlsx',
          },
          {
            id:4,
            fileName:'SANGFOR_IAM_Pre-POC Test Plan_v1.1.xlsx',
            fileUrl:'SANGFOR_IAM_Pre-POC Test Plan_v1.1.xlsx',
            fileType:'xlsx',
          },
          {
            id:5,
            fileName:'SANGFOR_IAM_v12.0.x_POC Test Guide.docx',
            fileUrl:'SANGFOR_IAM_v12.0.x_POC Test Guide.docx',
            fileType:'doc',
          },
          {
            id:6,
            fileName:'SANGFOR_POC Process_（SEA).docx',
            fileUrl:'SANGFOR_POC Process_（SEA).docx',
            fileType:'doc',
          },
          {
            id:7,
            fileName:'SANGFOR_POC Reporting Template_v1.0.pptx',
            fileUrl:'SANGFOR_POC Reporting Template_v1.0.pptx',
            fileType:'pptx',
          },
          {
            id:8,
            fileName:'Security Product_Implementation SOW.docx',
            fileUrl:'Security Product_Implementation SOW.docx',
            fileType:'doc',
          },
        ],
        15:[
          {
            id:1,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Access Control Policy.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Access Control Policy.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain ADSSO.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain ADSSO.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain IWA SSO.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain IWA SSO.pdf',
            fileType:'pdf',
          },
          {
            id:4,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain Script SSO.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Activity Domain Script SSO.pdf',
            fileType:'pdf',
          },
          {
            id:5,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Audit Policy .pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Audit Policy .pdf',
            fileType:'pdf',
          },
          {
            id:6,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Bandwidth Management.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Bandwidth Management.pdf',
            fileType:'pdf',
          },
          {
            id:7,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Radius SSO.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Radius SSO.pdf',
            fileType:'pdf',
          },
          {
            id:8,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_SSL Content Decryption.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_SSL Content Decryption.pdf',
            fileType:'pdf',
          },
          {
            id:9,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Sync Log to Report Center .pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Sync Log to Report Center .pdf',
            fileType:'pdf',
          },
          {
            id:10,
            fileName:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Use IAM as a Proxy Server to A.pdf',
            fileUrl:'SANGFOR_IAM_v12.0.42_Best Practices for Scenarios_Use IAM as a Proxy Server to A.pdf',
            fileType:'pdf',
          },
        ],
        16:[
          {
            id:1,
            fileName:'Tender Specification IAG13.0.15 template_12JAN2021.xlsx',
            fileUrl:'Tender Specification IAG13.0.15 template_12JAN2021.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'Tender Specification IAG13.0.15 template_12MAR2021.xlsx',
            fileUrl:'Tender Specification IAG13.0.15 template_12MAR2021.xlsx',
            fileType:'xlsx',
          },
          {
            id:3,
            fileName:'Tender Specification IAG13.0.15 template_19JAN2021.xlsx',
            fileUrl:'Tender Specification IAG13.0.15 template_19JAN2021.xlsx',
            fileType:'xlsx',
          },
          {
            id:4,
            fileName:'Tender Specification IAM13.0.14 template_11NOV2020.xlsx',
            fileUrl:'Tender Specification IAM13.0.14 template_11NOV2020.xlsx',
            fileType:'xlsx',
          },
        ],
        17:[],
        18:[
          {
            id:1,
            fileName:'[Security Webinar] Lessons Learned From Data Breaches to Better Protect Yourself.pptx',
            fileUrl:'[Security Webinar] Lessons Learned From Data Breaches to Better Protect Yourself.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'01 IAM 12.0.18 release 20181031.pptx',
            fileUrl:'01 IAM 12.0.18 release 20181031.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Continuous_Asset_Monitoring_to_Accelerate_RemediationV3.pptx',
            fileUrl:'Continuous_Asset_Monitoring_to_Accelerate_RemediationV3.pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'Debunking the Myth _PP_P_NGFW vs SWG_20201214.pptx',
            fileUrl:'Debunking the Myth _PP_P_NGFW vs SWG_20201214.pptx',
            fileType:'pptx',
          },
          {
            id:5,
            fileName:'IAM is New &amp;amp; Improved SaaS with CASB &amp;amp; 12.0.23 release.pptx',
            fileUrl:'IAM is New &amp;amp; Improved SaaS with CASB &amp;amp; 12.0.23 release.pptx',
            fileType:'pptx',
          },
          {
            id:6,
            fileName:'IAM_P_PP_Sangfor_IAM_V1308_Internal_20200923 Rev3 (1).pptx',
            fileUrl:'IAM_P_PP_Sangfor_IAM_V1308_Internal_20200923 Rev3 (1).pptx',
            fileType:'pptx',
          },
          {
            id:7,
            fileName:'IAM_P_PP_Sangfor_IAM_V1308_Internal_20200923 Rev3.pptx',
            fileUrl:'IAM_P_PP_Sangfor_IAM_V1308_Internal_20200923 Rev3.pptx',
            fileType:'pptx',
          },
          {
            id:8,
            fileName:'Internet_ PP_P_Securing_Internet_Gateway_Vital R1 20201116_Eugene.pptx',
            fileUrl:'Internet_ PP_P_Securing_Internet_Gateway_Vital R1 20201116_Eugene.pptx',
            fileType:'pptx',
          },
          {
            id:9,
            fileName:'Sangfor IAM is Authentication Made Easy V.4.pptx',
            fileUrl:'Sangfor IAM is Authentication Made Easy V.4.pptx',
            fileType:'pptx',
          },
          {
            id:10,
            fileName:'SANGFOR_BI_Video_0724_Rev_JO V.4.pptx',
            fileUrl:'SANGFOR_BI_Video_0724_Rev_JO V.4.pptx',
            fileType:'pptx',
          },
          {
            id:11,
            fileName:'Securing internet gateway is vital for your security posture_v2.pptx',
            fileUrl:'Securing internet gateway is vital for your security posture_v2.pptx',
            fileType:'pptx',
          },
        ],
        19:[
          {
            id:1,
            fileName:'IAM main sales scenario and target market 20190610.pptx',
            fileUrl:'IAM main sales scenario and target market 20190610.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'IAM_PartnerPresales_Bootcamp_Nov2020_v2.pptx',
            fileUrl:'IAM_PartnerPresales_Bootcamp_Nov2020_v2.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Security Partner Enablement Enterprise.pptx',
            fileUrl:'Security Partner Enablement Enterprise.pptx',
            fileType:'pptx',
          },
          {
            id:1,
            fileName:'Partner certification Role play – IAM.docx',
            fileUrl:'Partner certification Role play – IAM.docx',
            fileType:'doc',
          },
        ],
        20:[],
        21:[],
        22:[],
        23:[
          {
            id:1,
            fileName:'Video Training',
            fileUrl:'https://community.sangfor.com/plugin.php?id=sangfor_databases:index&mod=viewdatabase&tid=3356',
            fileType:'video',
          },
        ],
      },
      fileImg:{
        ppt:require('../../../assets/img/ppt.png'),
        doc:require('../../../assets/img/doc.png'),
        pdf:require('../../../assets/img/pdf.png'),
      }
    };
  },
  methods: {
    handleNodeClick(data) {
      if (data.child_id) {
        this.showItem = data.child_id;
        this.mainTitle = data.label;
        this.pagination.total = this.feilIndexData[data.child_id].length;
        this.fileMainItemData = this.feilIndexData[data.child_id];
        this.pagination.data = this.feilIndexData[data.child_id];
        if (this.pagination.total > 8) {
          this.fileMainItemData = this.fileMainItemData.slice(0, 8);
        }
      }
    },
    handleCurrentChange(val) {
      let sliceEnd = val * 8;
      let sliceStart = sliceEnd - 8;
      this.fileMainItemData = this.pagination.data.slice(sliceStart, sliceEnd);
    },
    //初始化渲染
    initRender() {
      if (this.feilIndexData[1].length > 8) {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1].slice(0, 8);
      } else {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1];
      }
    },
    downFeil(item,type) {
      if(type!='video'){
        var a = document.createElement("a");
        var filename = item;
        a.href =getCurrentHost()+ item;
        a.download = filename;
        a.click();
      }else{
        window.open(item);
      } 
    },
  },
  mounted() {
    this.initRender()
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(20);
    });
  },
};
</script>

<style scoped lang="scss">
.iagIndex {
  width: 100%;
  padding: 5px 17px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  .feil_menu {
    width: 20%;
    background: #1688e1;
    .feil_menu_title {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 600;
      color: #eaf3f4;
    }
  }
  .feil_main {
    width: 79.5%;
    background: #eff6ff;
    .feil_main_title {
      width: 100%;
      height: 46px;
      background: #1688e1;
      line-height: 46px;
      font-size: 16px;
      text-align: left;
      padding: 0 40px;
      color: #eaf3f4;
    }
    .feil_main_item {
      width: 100%;
      height: 680px;
      padding: 10px;
      .feil_main_item_ul {
        width: 100%;
        .feil_main_item_li {
          padding: 10px;
          .content {
            width: 100%;
            display: flex;
            background: #fff;
            padding: 10px 20px;
            border-radius: 8px;
            justify-content: space-between;
            .content_icon {
              width: 4.5%;
              height: 42px;
              margin-right: 15px;
              background: #248fe6;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
              .svg-icon {
                font-size: 28px;
                color: #fff;
                font-weight: 600;
              }
            }
            .content_down {
              width: 4%;
              display: flex;
              align-items: center;
              justify-content: center;
              .svg-icon {
                font-size: 24px;
                color: #248fe6;
              }
            }
            .content_title {
              width: 90%;
              display: flex;
              align-items: center;
              font-size: 14px;
              p {
                width: 100%;
                text-align: left;
                color: #248fe6;
                font-weight: 600;
              }
            }
          }
        }
      }
      .noDetail{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .svg-icon{
          font-size: 60px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
</style>